import { api } from '../api';

export interface BloqueadoItem {
  asociadoId: string;
  documento: string;
  nombre: string;
  legajo: string;
  esTitular: boolean;
  motivo: string;
  bloqueadoAt: string;
  bloqueadoPor: string;
}
export interface BloqueadosPage {
  items: BloqueadoItem[];
  total: number;
  page: number;
  pageSize: number;
}

/** Lista paginada (solo lectura) de personas bloqueadas. Filtro `q` por DNI/legajo/nombre. */
export async function getBloqueados(page = 1, pageSize = 100, q = ''): Promise<BloqueadosPage> {
  const { data } = await api.get<BloqueadosPage>('/bloqueados', { params: { page, pageSize, q } });
  return data;
}
